import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Product} from "../../models/product";
import {Router} from "@angular/router";

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss']
})
export class ListViewComponent implements OnInit {

  @Input() productList: any;
  @Input() searchKey = '';
  @Output() addItems: EventEmitter<any> = new EventEmitter();
  @Output() viewProduct: EventEmitter<Product> = new EventEmitter();

  // El padre le dirá al hijo en qué página está
  @Input() p: number = 1; 

  // El hijo le notificará al padre si la página cambia
  @Output() pageChange = new EventEmitter<number>();

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  addToCart(item: string) {
    this.addItems.emit(item);
  }

  viewProductDetail(product: any) {
    const truncatedDescription = this.getTruncatedDescription(product.description);
    
    this.router.navigate(['/product', product.id], {
      state: { product: { ...product, description: truncatedDescription } }
    }).then(() => {
      console.log('Navegación completada');
    });
  }

  truncateHtml(text: string, maxLength: number = 100): string {
    const div = document.createElement('div');
    div.innerHTML = text;
    let plainText = (div.textContent || div.innerText || '').replace(/\s+/g, ' ');
    return plainText.length > maxLength 
      ? plainText.substring(0, maxLength) + '...' 
      : plainText;
  }

  getTruncatedDescription(description: string): string {
    return this.truncateHtml(description, 250);
  }
}